var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.89999C16.8564 9.89999 17.2034 10.0182 17.4856 10.2349L23.3816 15.175C23.5515 15.318 23.65 15.5281 23.65 15.7503C23.65 16.1645 23.3139 16.5 22.8998 16.5H21.45V22C21.45 22.3041 21.2036 22.55 20.9 22.55H12.1C11.7964 22.55 11.55 22.3041 11.55 22V16.5H10.0996C9.68548 16.5 9.34998 16.1645 9.34998 15.7503C9.34998 15.5287 9.44843 15.318 9.61838 15.1756L15.5144 10.2355C15.7965 10.0182 16.1436 9.89999 16.5 9.89999Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28693 3.4782C7.54928 3.2923 7.81713 3.1141 8.09103 2.9436",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38928 11.3795C2.27863 8.75434 3.83293 6.43609 5.85143 4.62439",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2943 31.7169C21.0171 31.8038 20.7366 31.8841 20.4528 31.9567",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2064 22.6853C29.5966 26.5084 26.5391 29.5724 22.7205 31.1916",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9806 23.7968C22.0825 25.7422 19.4326 26.95 16.5 26.95C10.7289 26.95 6.05 22.2711 6.05 16.5C6.05 12.936 7.645 9.78393 10.3576 7.89798C10.7459 7.59603 11 7.12963 11 6.59998C11 5.68863 10.2614 4.94998 9.35 4.94998C9.00185 4.94998 8.67955 5.05888 8.41335 5.24313C4.9115 7.74068 2.75 11.8706 2.75 16.5C2.75 24.0938 8.90615 30.25 16.5 30.25C24.0939 30.25 30.25 24.0938 30.25 16.5C30.25 11.8706 28.0885 7.74068 24.5866 5.24313C24.3204 5.05888 23.9982 4.94998 23.65 4.94998C22.7387 4.94998 22 5.68863 22 6.59998C22 7.12963 22.2541 7.59603 22.6424 7.89798C25.355 9.78393 26.95 12.936 26.95 16.5C26.95 17.8222 26.7041 19.0877 26.2559 20.2521",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6261 21.5946C25.4655 21.8812 25.2923 22.16 25.1064 22.4295",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 1.64999H17.6C17.9036 1.64999 18.15 1.89584 18.15 2.19999V6.59999C18.15 6.90414 17.9036 7.14999 17.6 7.14999H15.4C15.0964 7.14999 14.85 6.90414 14.85 6.59999V2.19999C14.85 1.89584 15.0964 1.64999 15.4 1.64999Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.df800db5.svg";
export { ForwardRef as ReactComponent };